import { DateValue } from 'react-aria-components';

import { RangeValue } from '@react-types/shared';
import AWS from 'aws-sdk';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

// const S3_BUCKET = process.env.REACT_APP_S3_NAME;
// const REGION = process.env.REACT_APP_S3_REGION;

AWS.config.update({
  accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_S3_SECRET_ACCESS_KEY,
});

export const cleanInput = (input: { __typename: any }) => {
  if (!_.isEmpty(input.__typename)) {
    delete input.__typename;
  }
  return input;
};

export const truncateText = (text: string, size: number) => {
  if (size === 0 && text.length > 50) {
    return `${text.substring(0, 50)}...`;
  }
  if (size === 1 && text.length > 150) {
    return `${text.substring(0, 150)}...`;
  }
  if (size === 2 && text.length > 250) {
    return `${text.substring(0, 250)}...`;
  }
  return text;
};

export const truncatePrice = (price: any) => {
  if (price / 1000 < 1) {
    return parseInt(price).toString();
  } else {
    return (price / 1000).toFixed(1).toString() + 'k';
  }
};

export const removeProp = (object: { [x: string]: any }, prop: string | number) => {
  if (!_.isEmpty(object[prop])) {
    delete object[prop];
  }
  return object;
};

export const getDateDiff = (a: string | number | Date, b: string | number | Date) => {
  if (_.isEmpty(a) || _.isEmpty(b)) {
    return 0;
  }
  const Difference_In_Time = new Date(b).getTime() - new Date(a).getTime();

  console.log(Difference_In_Time / (1000 * 3600 * 24));

  return Difference_In_Time / (1000 * 3600 * 24);
};

export const formatMMDDYYYY = (date: {
  getMonth: () => number;
  getDate: () => any;
  getFullYear: () => string;
}) => {
  return (
    (date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
    '/' +
    (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) +
    '/' +
    date.getFullYear()
  );
};

export const isUserInfoEmpty = (userInfo: { id: any }) => {
  if (!_.isEmpty(userInfo)) {
    if (!_.isEmpty(userInfo.id)) {
      return false;
    }
  }
  return true;
};

export const getTotalCost = (
  totalRent: number,
  securityDeposit: number,
  start: any,
  end: any,
) => {
  totalRent = Number(totalRent);
  securityDeposit = Number(securityDeposit);

  const dailyRate = totalRent / 30;

  const total = dailyRate * getDateDiff(start, end);
  return total + securityDeposit + 100;
};

export const getImageLabel = (file: string) => {
  const regex = /^[^_]*_([^_]+)_.*$/;
  const match = file.match(regex);
  if (match) {
    return match[1];
  }
  return '';
};

export const getUrlSafe = (text: string) => {
  return text.replace(/ /g, '%20');
};

export const stripStateFromSearchTerm = (text: string | string[]) => {
  const index = text.indexOf(',');
  return index >= 0 ? text.slice(0, index) : text;
};

export const getRandomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const extractAndStripParentheses = (inputString: string) => {
  // Use a regular expression to find text between parentheses
  const regex = /\(([^)]*)\)/g;

  // Initialize an array to store the extracted text
  let extractedText = '';

  // Use the replace() method to remove the parentheses and extract the content between them
  const strippedString = inputString.replace(regex, (match, group) => {
    extractedText = group;
    return ''; // Replace the matched substring with an empty string
  });

  // Return a tuple with the stripped string and the extracted text
  return [strippedString.trim(), extractedText];
};

export const getGuid = () => {
  return uuidv4();
};

export const changeImageFileName = (fileName: string, origin: any, userId: any) => {
  const splitName = fileName.split('.');
  const extension = splitName.at(-1);

  userId = !_.isEmpty(userId) ? userId : 'UNKNOWN';

  const imageGuid = getGuid();

  const result = `${userId}_${origin}_${imageGuid}.${extension}`;

  return result;
};

export const formatUsd = (number?: number | null) => {
  return typeof number === 'number'
    ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(number)
    : '';
};
